// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__Fjiic","head":"ProcedureTableInfo_head__38JYf"};